import React from 'react'
import { Body } from '../../../src/components/global/typography/style'
import formatInlineCode from '../../../src/utils/shortTextFormatting'

const handleLinksWithLinebreaks = (children: any) => {
  let childElement
  childElement = children.map((item: any, index: number) => {
    return formatInlineCode(item)
  })

  return <Body>{childElement}</Body>
}

export const paragraph = (node: any, children: any) => {
  if (node) {
    if (children && children.length === 1 && typeof children[0] === 'string') {
      //* handles the case where a paragraph has a single child that is string
      return <Body>{formatInlineCode(children[0])}</Body>
    } else if (children && children.length > 0) {
      return handleLinksWithLinebreaks(children)
    } else {
      return <Body>{children}</Body>
    }
  } else {
    return null
  }
}

export const listItem = (node: any, children: any) => {
  if (node && children) {
    return <li className="richText-styled-list-items">{children}</li>
  }
}

export const listStyle = (node: any, children: any) => {
  if (node && children) {
    return node.nodeType === 'unordered-list' ? (
      <ul className="richText-styled-list">{children}</ul>
    ) : (
      <ol className="richText-styled-list">{children}</ol>
    )
  }
}

export const quoteBlock = (node: any, children: any) => {
  if (node && node.content) {
    let isQuote = ''
    let text =
      (node.content[0]?.content &&
        node.content[0].content[0] &&
        node.content[0].content[0].value) ||
      ''

    if (text) {
      isQuote = text.startsWith('"') || text.startsWith("'") || text.startsWith('“')

      if (isQuote && children && children.length > 1) {
        text = text.slice(1, -1)
        const modifiedChild = { ...children[0] }
        const modifiedChildProps = {
          ...modifiedChild.props,
          ...{ children: text },
        }

        return (
          <blockquote className={`quote-container ${isQuote ? 'is-quote' : ''}`}>
            {[{ ...modifiedChild, props: modifiedChildProps }, { ...children[1] }]}
          </blockquote>
        )
      }
    }

    return children ? (
      <blockquote className={`quote-container ${isQuote ? 'is-quote' : ''}`}>{children}</blockquote>
    ) : null
  } else {
    return null
  }
}

export const code = (text: string) => {
  if (text.length) {
    return <span className="code-block-wrapper">{text}</span>
  }
}
